import React from 'react';
import NoInternetConnectivity from '../../assets/svg/no_internet_connectivity.svg';
import MaterialButton from '../../Components/Buttons/material/materialButton';
import './styles/offlineScreen.scss';

function OfflineScreen() {
    const buttons = [
        {
            text: "Refresh",
            onClick: function () {
                window.location.reload()
            },
            classes: "btn green full-width"
        }
    ]
    return (
        <div className="no-internet-connectivity">
            <img src={NoInternetConnectivity} width="320" height="320" alt="No Internet Connectivity" />
            <div className="m-t-20" style={{ textAlign: "center" }}>
                <b style={{ fontSize: '24px', fontWeight: '900', color: '#000' }}>Oops! You got disconnected.</b>
                <p style={{ fontSize: '18px' }}>Check your internet connection and try again.</p>
                <MaterialButton buttons={buttons} />
            </div>
        </div>
    );
}

export default OfflineScreen;